import {html} from 'lit'

const splash = html`
    <div class="app-splash">
        <div class="inner">
            <img alt="This is an image of the coffee on café logo." class="app-logo" src="/images/logo-primary.svg"/>
            <sl-spinner style="font-size: 2em;"></sl-spinner>
        </div>
    </div>
`
export default splash